import { render, staticRenderFns } from "./PlayerBrowser.vue?vue&type=template&id=6c5474ff"
import script from "./PlayerBrowser.vue?vue&type=script&lang=js"
export * from "./PlayerBrowser.vue?vue&type=script&lang=js"
import style0 from "./PlayerBrowser.vue?vue&type=style&index=0&id=6c5474ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports